<template>
  <LayoutAdmin @click="activeDropdown = false" :active-periode="activePeriodic">
    <section class="w-full px-8 mt-6 overflow-x-hiden">
      <section class="flex justify-between">
        <section class="flex items-center">
          <h1 class="text-2xl">Need Approval</h1>
          <ChoiseCompany v-if="!loading?.getCompany && optionsCompany.length"
            @selected:company="dataCompany = $event" :options="optionsCompany" :dataCompany="dataCompany" />
        </section>
      </section>
      <section class="flex flex-wrap items-center w-10/12 mt-6">
        <Button class="w-10 h-10 bg-white rounded-full shadow-md text-primary" @click="handleShowLayoutData">
          <font-awesome-icon icon="fa-table" />
        </Button>
        <Dropdown title="Departemen" :showDropdown="activeDropdown === 'departemen'" :options="departements"
          property="dep_name" :selected-option="filter.departement" @selected="(e) => filterByDepartement(e)"
          @clearSelected="filterByDepartement(null)" @update:activeDropdown="(e) => changeDropdownActive('departemen')" />
        <Dropdown title="Employee" :showDropdown="activeDropdown === 'employee'" :options="employment" property="emp_name"
          :selected-option="filter.employee" @selected="(e) => filterByEmployee(e)"
          @clearSelected="filterByEmployee(null)" @update:activeDropdown="changeDropdownActive('employee')" />
      </section>
      <section class="w-full">
        <p class="mt-5 mb-3 text-sm text-gray-300">
          Showing 1 to 10 items of 11
        </p>
        <TableNeedApproval :overtime_request="filterOvertimeRequest" :showMessageStatus="showMessageStatus"
          :loading="loading.getOvertimeRequest" :getNeedApproval="getNeedApproval" />
      </section>
    </section>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from "../../components/Layout/Admin.vue";
import Button from "../../components/Button.vue";
import Dropdown from "../../components/Dropdown.vue";
import TableNeedApproval from "../../components/TableNeedApproval.vue";
import { GetAllEmployementAPI } from "@/actions/employment";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import { GetNeedApprovalAPI } from "@/actions/need-approval";
import { GetDepartementAPI } from "@/actions/departement";
import { GetPeriodicActiveAPI } from "@/actions/periodic";
import decryptToken from "@/utils/decryptToken";
import ChoiseCompany from "@/components/ChoiseCompany.vue";

export default {
  name: "OvertimeRequest",
  components: {
    LayoutAdmin,
    Button,
    ChoiseCompany,
    TableNeedApproval,
    Dropdown,
  },
  data() {
    return {
      activeDropdown: "",
      activePeriodic: "-",
      layoutData: "card",
      modal: {
        showModal: false,
        showSelect: false,
      },
      employment: [],
      optionsCompany: [],
      superAdmin: false,
      overtime_requests: [],
      dataCompany: {},
      loading: {
        getCompany: true,
        getOvertimeRequest: true,
        addOvertimeRequest: false,
      },
      filter: {
        departement: this.$store.state.filter.departement,
        employee: "",
      },
      departements: [],
    };
  },
  computed: {
    filterOvertimeRequest() {
      return this.overtime_requests.map((request) => {
        const dataFilter = request.data.filter(
          (data) => data.emp_id.emp_depid !== null
        );
        return { type: request.type, data: dataFilter };
      });
    },
  },
  methods: {
    changeDropdownActive(id) {
      if (this.activeDropdown === id) {
        this.activeDropdown = false;
      } else {
        this.activeDropdown = id;
      }
    },
    async handleGetEmployement() {
      const querySuperAdmin = `?company=${this.dataCompany._id}`;
      const response = await GetAllEmployementAPI(querySuperAdmin);
      if (response.status === 401) {
        this.$store.commit("changeIsLoggedIn", false);
        return this.$router.push("/login");
      }
      const getIdNameEmp = response?.data?.map((employment) => ({
        _id: employment?._id,
        emp_name: employment?.emp_fullname,
      }));
      this.employment = getIdNameEmp;
    },
    async getNeedApproval() {
      this.loading.getOvertimeRequest = true;
      const companyId = this.dataCompany?._id;
      const departementId = this.filter.departement?._id;
      const employeeId = this.filter.employee?._id;
      const response = await GetNeedApprovalAPI({
        companyId,
        departementId,
        employeeId,
      });
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        this.overtime_requests = response.data;
      }

      this.loading.getOvertimeRequest = false;
    },
    async getAllCompany() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.optionsCompany = response.data;
      this.dataCompany = response.data[0];
      this.loading.getCompany = false;
    },
    async getDepartement() {
      const querySuperAdmin = `?company=${this.dataCompany?._id}`;
      const response = await GetDepartementAPI(querySuperAdmin);
      if (response.status === 401) {
        return this.$router.push("/login");
      }
      this.departements = response.data;
    },
    filterByDepartement(e) {
      this.filter.departement = e;
      this.getNeedApproval();
    },
    filterByEmployee(e) {
      this.filter.employee = e;
      this.getNeedApproval();
    },
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.dataCompany?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
  },
  watch: {
    dataCompany: {
      handler: function () {
        this.handleGetEmployement();
        this.getNeedApproval();
        this.getDepartement();
        this.handleGetPeriodicActive();
      },
      deep: true,
    },
  },
  mounted() {
    const payload = decryptToken();
    this.superAdmin =
      payload?.role === "Super Admin" || payload?.role === "Group Admin";
    this.getAllCompany();
  },
};
</script>

<style scoped></style>
